import { RootState } from "@/reducers/store"
import { ChatSettings } from "@/reducers/chatsSettingsSlice"
import { createSelector } from "@reduxjs/toolkit"
import { selectChats } from "@/reducers/chatsSliceSelectors"

type Jid = string

// First create a selector that just gets the chatsSettings
const selectChatsSettings = (state: RootState) => state.chatsSettings

export const selectChatSettings = (chatJid: Jid) => {
  return (state: RootState): ChatSettings | undefined =>
    state.chatsSettings[chatJid]
}

export const selectIsChatMuted = (chatJid: Jid) => {
  return (state: RootState): boolean =>
    state.chatsSettings[chatJid]?.muted ?? false
}

export const selectArchivedChats = createSelector(
  [selectChatsSettings],
  (chatsSettings): Jid[] => {
    return Object.entries(chatsSettings)
      .filter(([_, settings]) => settings.archived === true)
      .map(([jid]) => jid)
  },
)
export const selectShouldNotify =
  (chatJid: Jid) =>
  (state: RootState): boolean => {
    return (
      !state.chatsSettings[chatJid]?.muted &&
      !state.chatsSettings[chatJid]?.archived
    )
  }

export const selectFirstNonArchiveDriverJid = createSelector(
  [selectChats, selectArchivedChats],
  (chats, archivedChats) =>
    chats.find(
      (chat) =>
        !archivedChats.includes(chat.jid) &&
        chat.participants.some((p) => p.role === "driver"),
    )?.jid ?? chats[0].jid,
)
